import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { faqs } from '../../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-cream px-4 py-12 sm:py-16" data-id="element-125" data-mp="x53cyzs363aq">
      <div className="mx-auto max-w-2xl" data-id="element-126" data-mp="1223kzg8hxg4h">
        <h2 className="text-center font-display text-[26px] font-black leading-tight text-navy-deep sm:text-4xl" data-id="element-127" data-mp="122vfenqcx7t6">
          Frequently Asked Questions
        </h2>

        <div className="mt-8 space-y-3" data-id="element-128" data-mp="1urk9w3wwqevy">
          {faqs.map((faq, index) => {
          const isOpen = open === index;
          return <div key={faq.q} className="overflow-hidden rounded-2xl border border-navy/12 bg-white" data-id="element-129" data-mp="1g0blfy4qqzke" data-mpi={index}>
                <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left" data-id="element-130" data-mp="28qtq33l458zx">
                  <span className="text-[14px] font-extrabold leading-snug text-navy-deep sm:text-[15px]" data-id="element-131" data-mp="2jre3l4pntujo">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-forest-mid transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-132" data-mp="2yhd1d6daz3ym" />
                </button>
                {isOpen && <p className="border-t border-navy/8 px-5 py-4 text-[14px] font-medium leading-relaxed text-ink/70" data-id="element-133" data-mp="3hemjmk6w6bea">
                    {faq.a}
                  </p>}
              </div>;
        })}
        </div>

        <div className="mx-auto mt-9 max-w-md" data-id="element-134" data-mp="1n1obo78nzqu4">
          <CTAButton label="Get the Kit today" sub="7-Day Guarantee · No Risk" data-id="element-135" data-mp="1i1s8ga7sk3fm" />
        </div>
      </div>
    </section>;
}